import { notification } from "antd";

export const notAuthorized = () => {
  notification.warn({
    message: "You do not have permission to do this operation",
  });
};
